import PedidoMaterial from './PedidoMaterial';

export default PedidoMaterial;